<div class="cp-page">
  <section class="cp-card">
    <div class="cp-card__header">
      <span class="eyebrow">Seguridad de la cuenta</span>
      <h2>Cambia tu contraseña</h2>
      @if (forced) {
        <p class="subtitle">
          Por motivos de seguridad debes establecer una nueva contraseña que
          cumpla la política actual antes de continuar usando la plataforma.
        </p>
      } @else {
        <p class="subtitle">
          Introduce tu contraseña actual y elige una nueva.
        </p>
      }
    </div>

    <form class="cp-form" (ngSubmit)="submit()">
      <div class="form-group">
        <label for="current-password">Contraseña actual</label>
        <input
          id="current-password"
          name="currentPassword"
          type="password"
          autocomplete="current-password"
          maxlength="128"
          [(ngModel)]="currentPassword"
          required
        />
      </div>

      <div class="form-group">
        <label for="new-password">Nueva contraseña</label>
        <input
          id="new-password"
          name="newPassword"
          type="password"
          autocomplete="new-password"
          [minlength]="passwordMinLength"
          maxlength="128"
          [(ngModel)]="newPassword"
          required
        />

        @if (newPassword) {
          <div class="password-meter" [attr.data-score]="passwordScore">
            <span class="password-meter__bar"></span>
            <span class="password-meter__bar"></span>
            <span class="password-meter__bar"></span>
            <span class="password-meter__bar"></span>
            <span class="password-meter__label">{{ passwordScoreLabel }}</span>
          </div>
        }

        @if (passwordPolicyMessage) {
          <p class="field-help field-help--error">{{ passwordPolicyMessage }}</p>
        }

        <p class="field-help">
          Mínimo {{ passwordMinLength }} caracteres. Evita contraseñas comunes,
          secuencias (1234, abcd) y datos como tu usuario. Se admiten frases con
          espacios.
        </p>
      </div>

      <div class="form-group">
        <label for="confirm-password">Repite la nueva contraseña</label>
        <input
          id="confirm-password"
          name="confirmPassword"
          type="password"
          autocomplete="new-password"
          maxlength="128"
          [(ngModel)]="confirmPassword"
          required
        />
        @if (mismatch) {
          <p class="field-help field-help--error">
            La confirmación no coincide.
          </p>
        }
      </div>

      <button class="submit-button" type="submit" [disabled]="loading">
        {{ loading ? "Guardando..." : "Guardar y volver a entrar" }}
      </button>

      @if (!forced) {
        <button
          class="link-button"
          type="button"
          [disabled]="loading"
          (click)="cancel()"
        >
          Cancelar y cerrar sesión
        </button>
      }
    </form>

    <div class="cp-card__footer">
      <span class="footer-copy">
        Al guardar se cerrarán todas tus sesiones y tendrás que iniciar sesión
        de nuevo.
      </span>
      @if (forced) {
        <button
          class="link-button"
          type="button"
          [disabled]="loading"
          (click)="cancel()"
        >
          Cerrar sesión
        </button>
      }
    </div>
  </section>
</div>
